import React, {useState} from 'react'
import {rateContent, searchContentForReview} from "../services/ContentService";
import "../stylesheets/ContentReview.css";

const ContentReview = () => {

    const [query, setQuery] = useState("");
    const [content, setContent] = useState([]);
    const [searched, setSearched] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [updating, setUpdating] = useState({});

    function search(event) {
        event.preventDefault();
        const value = query.trim();
        if (!value) {
            return;
        }
        const token = localStorage.getItem("admin-token");
        setLoading(true);
        setError("");
        searchContentForReview(token, value)
            .then((res) => {
                setContent(res.data || []);
            })
            .catch(() => {
                setContent([]);
                setError("Search failed. Please try again.");
            })
            .finally(() => {
                setSearched(true);
                setLoading(false);
            })
    }

    function updateStatus(item, status) {
        const token = localStorage.getItem("admin-token");
        setUpdating(prev => ({...prev, [item.id]: true}));
        setError("");
        let ratingRequest = {};
        ratingRequest.status = status;
        if (status === "DENIED") {
            ratingRequest.rating = 0;
        }
        rateContent(ratingRequest, item.id, token)
            .then(() => {
                setContent(prev => prev.map(c => c.id === item.id ? {...c, status: status} : c));
            })
            .catch(() => {
                setError("Could not update content " + item.id + " to " + status + ".");
            })
            .finally(() => {
                setUpdating(prev => ({...prev, [item.id]: false}));
            })
    }

    return(
        <div className={"review-page"}>
            <form className={"review-search"} onSubmit={search}>
                <input type="text" className="form-control" placeholder="Content UUID or username"
                       value={query} onChange={(e) => setQuery(e.target.value)}/>
                <button type="submit" className={"btn btn-dark"} disabled={loading || !query.trim()}>
                    {loading ? "Searching..." : "Search"}
                </button>
            </form>
            {error && <div className={"alert alert-danger"}>{error}</div>}
            {searched && !loading && !error && content.length === 0 && <p>No content found.</p>}
            <div className={"review-results"}>
                {content.map(item => (
                    <div className={"review-card"} key={item.id}>
                        <img src={"https://d3p3fw3rutb1if.cloudfront.net/photos/" + item.img_preview_id}
                             className={"review-img"} alt={item.description || "content"}/>
                        <div className={"review-card-body"}>
                            <div className={"review-user"}>
                                {item.profile_image_exists &&
                                    <img src={"https://d3p3fw3rutb1if.cloudfront.net/users/" + item.user_id}
                                         className={"review-user-img"} alt=""/>}
                                <span>{item.username}</span>
                                <span className={"review-status review-status-" + (item.status || "").toLowerCase()}>
                                    {item.status || "UNKNOWN"}
                                </span>
                            </div>
                            {item.description && <p className={"review-description"}>{item.description}</p>}
                            <p className={"review-meta"}>{item.likes} likes · {item.views} views</p>
                            <p className={"review-meta"}>{item.id}</p>
                            <div className={"review-buttons"}>
                                <button className={"btn btn-success"}
                                        disabled={updating[item.id] || item.status === "APPROVED"}
                                        onClick={() => updateStatus(item, "APPROVED")}>Approve</button>
                                <button className={"btn btn-danger"}
                                        disabled={updating[item.id] || item.status === "DENIED"}
                                        onClick={() => updateStatus(item, "DENIED")}>Deny</button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ContentReview
